import { render, staticRenderFns } from "./gnss-menu.vue?vue&type=template&id=661796c6&scoped=true"
import script from "./gnss-menu.vue?vue&type=script&lang=js"
export * from "./gnss-menu.vue?vue&type=script&lang=js"
import style0 from "./gnss-menu.vue?vue&type=style&index=0&id=661796c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661796c6",
  null
  
)

export default component.exports